import { node } from "~/util/dom";

export function createMarkerPopup() {
	return node("div", { className: "ui-marker-popup" });
}
